import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Menu.css";
import logo from "../../assets/logo.png";
const Menu = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (isOpen && window.scrollY > 50) {
        onClose();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <div className={`menu ${isOpen ? "open" : ""}`}>
      <div className="menu-header">
        <img src={logo} alt="Logo" className="menu-logo" />
        <button className="menu-close" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="menu-content">
        <div className="menu-links">
          <Link to="/" onClick={onClose}>
            Home
          </Link>
          <Link to="/product" onClick={onClose}>
            Our Products
          </Link>
          <Link to="/who-we-are" onClick={onClose}>
            Who We Are
          </Link>
          <Link to="/contact" onClick={onClose}>
            Contact Us
          </Link>
        </div>
        <div className="menu-info">
          <p>
            Wanna build your own brand or need bulk production for your current
            business? We will be your trusted partners!
          </p>
          <Link to="/contact" className="cta-button-menu" onClick={onClose}>
            Get a Quote
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Menu;
